<div class="layout-footer">
    <img [src]="currentLogo"  alt="Logo" height="20" class="mr-2" style="border-radius: 50%;"/>
    by
    <span class="font-medium ml-2">{{this.appName}}</span>
</div>